module.exports = __webpack_public_path__ + "static/media/share-mail-card.f562c6f4.png";